module.exports = __webpack_public_path__ + "static/media/linkBottomImg2.bce1c128.png";